import Vue from 'vue';

const success = (context, user) => {
  toastr.success('User Confirmed Successfully');
  user.confirmed = 1;
};

const failed = () => {
  toastr.error('Something went wrong');
};

export default (context, user) => Vue.$http.get(`users/confirm/${user.id}`).then((response) => {
  if (response && response.status === 200) {
    success(context, user);
  }
}).catch(() => {
  failed(context);
});



// WEBPACK FOOTER //
// ./src/app/services/account/confirmUser.js